import { Box, CircularProgress } from '@mui/material'

/** Shown in the admin main pane while a lazy page chunk loads. */
const AdminPageLoading = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        py: 10,
      }}
    >
      <CircularProgress aria-label="laddar..." />
    </Box>
  )
}

export default AdminPageLoading
